export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const LotteryGames = {
  LotteryGames: {
    slide1: {
      EuroCup: {
        redirectUrl: "/casino/qtechmobilots-euro-cup",
        code: "",
        casino: "Mobilots",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/EuroCup.png",
        alt: "",
        name: "Euro Cup",
        providerName: "QTECH",
      },
      CopaAmericaGame: {
        redirectUrl: "/casino/qtechmobilots-copa-america-game",
        code: "",
        casino: "Mobilots",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/CopaAmerica.png",
        alt: "",
        name: "Copa América Game",
        providerName: "QTECH",
      },
      HotGear: {
        redirectUrl: "/casino/qtechgalaxsys-hot-gear",
        code: "",
        casino: "Galaxsys",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/HotGear.png",
        alt: "",
        name: "Hot Gear",
        providerName: "QTECH",
      },
      LottoBoom: {
        redirectUrl: "/casino/qtechgalaxsys-lotto-boom",
        code: "",
        casino: "Galaxsys",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/LottoBoom.png",
        alt: "",
        name: "Lotto Boom",
        providerName: "QTECH",
      },
      BingoStar: {
        redirectUrl: "/casino/qtechgalaxsys-bingo-star",
        code: "",
        casino: "Galaxsys",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/BingoStarnew.webp",
        alt: "",
        name: "Bingo Star",
        providerName: "QTECH",
      },
      Keno10Minute1: {
        redirectUrl: "/casino/qtechgalaxsys-keno-10-1-minute",
        code: "",
        casino: "Galaxsys",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/Keno10.webp",
        alt: "",
        name: "Keno 10 (1 Minute)",
        providerName: "QTECH",
      },
      Keno10Minute2: {
        redirectUrl: "/casino/qtechgalaxsys-keno-10-2-minute",
        code: "",
        casino: "Galaxsys",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/Keno102min.webp",
        alt: "",
        name: "Keno 10 (2 Minute)",
        providerName: "QTECH",
      },
      KenoExpress: {
        redirectUrl: "/casino/qtechgalaxsys-keno-express",
        code: "",
        casino: "Galaxsys",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/KenoExpressnew.webp",
        alt: "",
        name: "Keno Express",
        providerName: "QTECH",
      },
      MultiDragonClassic: {
        redirectUrl: "/casino/qtechs4gaming-multi-dragon-classic",
        code: "",
        casino: "S4 Gaming",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/multidragonclassicnew.webp",
        alt: "",
        name: "Multi Dragon Classic",
        providerName: "QTECH",
      },
      SpinAndWin: {
        redirectUrl: "/casino/qtechkironinteractive-spin-and-win",
        code: "",
        casino: "Kiron Interactive",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/kironinteractive-spin-and-win.webp",
        alt: "",
        name: "Spin And Win",
        providerName: "QTECH",
      },
      MagicKeno: {
        redirectUrl: "/casino/qtechturbogames-magic-keno",
        code: "",
        casino: "Turbo Games",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/MagicKenonew.webp",
        alt: "",
        name: "Magic Keno",
        providerName: "QTECH",
      },
      CataratasBingo: {
        redirectUrl: "/casino/qtechwoohoogames-cataratas-bingo",
        code: "",
        casino: "Woohoo Games",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/cataratas-bingo.webp",
        alt: "",
        name: "Cataratas Bingo",
        providerName: "QTECH",
      },
      GoGoBingo: {
        redirectUrl: "/casino/qtechwoohoogames-go-go-bingo",
        code: "",
        casino: "Woohoo Games",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/Gogobingonew.webp",
        alt: "",
        name: "Go-Go Bingo",
        providerName: "QTECH",
      },
      KenoDraw: {
        redirectUrl: "/casino/qtechwoohoogames-keno-draw",
        code: "",
        casino: "Woohoo Games",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/keno-draw.webp",
        alt: "",
        name: "Keno Draw",
        providerName: "QTECH",
      },
      PescaBingo: {
        redirectUrl: "/casino/qtechwoohoogames-pesca-bingo",
        code: "",
        casino: "Woohoo Games",
        provider: "QTECH",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/lottery/pesca-bingo.webp",
        alt: "",
        name: "Pesca Bingo",
        providerName: "QTECH",
      },
      // EgyptianRichesGold: {
      //   redirectUrl: "/casino/qtechvibragaming-egyptian-riches-gold-u2457",
      //   code: "",
      //   casino: "Vibra Gaming",
      //   provider: "QTECH",
      //   homeUrl: "http://localhost:3000/Casino",
      //   imgUrl: "./images/lottery/Egyptian-riches-gold.webp",
      //   alt: "",
      //   name: "Egyptian Riches Gold",
      //   providerName: "QTECH",
      // },
    },
    name: "Lottery",
    key: "Lottery",
  },
};
